import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgObjectDetection = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 30,
	height: 30,
	viewBox: "5 5 20 20",
	fill: "black",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.6875 7.0625H11.3125C10.8898 7.0625 10.4844 7.23041 10.1855 7.5293C9.88666 7.82818 9.71875 8.23356 9.71875 8.65625V20.3438C9.71875 20.7664 9.88666 21.1718 10.1855 21.4707C10.4844 21.7696 10.8898 21.9375 11.3125 21.9375H17.6875C18.1102 21.9375 18.5156 21.7696 18.8145 21.4707C19.1133 21.1718 19.2812 20.7664 19.2812 20.3438V8.65625C19.2812 8.23356 19.1133 7.82818 18.8145 7.5293C18.5156 7.23041 18.1102 7.0625 17.6875 7.0625ZM10.7812 10.25H18.2188V18.75H10.7812V10.25ZM11.3125 8.125H17.6875C17.8284 8.125 17.9635 8.18097 18.0632 8.2806C18.1628 8.38023 18.2188 8.51535 18.2188 8.65625V9.1875H10.7812V8.65625C10.7812 8.51535 10.8372 8.38023 10.9368 8.2806C11.0365 8.18097 11.1716 8.125 11.3125 8.125ZM17.6875 20.875H11.3125C11.1716 20.875 11.0365 20.819 10.9368 20.7194C10.8372 20.6198 10.7812 20.4846 10.7812 20.3438V19.8125H18.2188V20.3438C18.2188 20.4846 18.1628 20.6198 18.0632 20.7194C17.9635 20.819 17.8284 20.875 17.6875 20.875Z",
		stroke: "none",
		fill: "evenodd"
	})
});
export default SvgObjectDetection;
